var $d77d0548e5e0fbff$exports = {};
$d77d0548e5e0fbff$exports = {
    "loading": `\u{B85C}\u{B4DC} \u{C911}\u{2026}`,
    "loadingMore": `\u{CD94}\u{AC00} \u{B85C}\u{B4DC} \u{C911}\u{2026}`
};


export {$d77d0548e5e0fbff$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
